import { useEffect, useReducer, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useFetch from './../hook/useFetch';
import parse from 'html-react-parser';
import { notificationActions } from "../store/notification-slice";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "./InfoIcon";

export default function Signup() {

    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'confirmation_password':
                return { ...state, confirmation_password: action.data }
            case 'username':
                return { ...state, username: action.data }
            default:
                return state

        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {
        email: null,
        password: null,
        confirmation_password: null,
        username: null
    })

    let dispatch = useDispatch()

    const { error, post, get } = useFetch()

    let navigate = useNavigate()

    const [inputpasswordtype, setinputpasswordtype] = useState('password')

    const [inputpasswordicon, setpasswordicon] = useState(faEyeSlash)

    const [registrationToken, setRegistrationToken] = useState(null)

    const [website, setWebsite] = useState('')

    useEffect(() => {
        get('/user/register-token', null, null, (data) => {
            setRegistrationToken(data?.data?.token || null)
        })
        // useFetch returns a new callback per render; this request must run only once per form mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        setpasswordicon(inputpasswordtype === 'text' ? faEyeSlash : faEye)

    }, [inputpasswordtype])

    return <div className="login-container" >
        <form className="login-form shadow" onSubmit={(e) => {
            e.preventDefault()

            post('/user', {
                email: componentState.email,
                password: componentState.password,
                confirmation_password: componentState.confirmation_password,
                username: componentState.username,
                registration_token: registrationToken,
                website,
                redirect: process.env.REACT_APP_BASE_URL

            }, null, (data) => {
                dispatch(notificationActions.setNotification({
                    message: 'please check your mailbox to activate you account',
                    status: true
                }))
                navigate('/')
            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{parse(error)}</p>
                </div>
            }

            <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
                <label htmlFor="signup-website">Website</label>
                <input id="signup-website" name="website" type="text" tabIndex="-1" autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
            </div>

            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Username</label>
                <input type="text" className="form-control" placeholder="Username" defaultValue={componentState.username} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'username',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email address</label>
                <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.email} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password</label>
                <div style={{ display: 'flex', alignItems: 'center' }} >
                    <input type={inputpasswordtype} className="form-control" placeholder="Password" defaultValue={componentState.password} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'password',
                                data: e.target.value
                            }
                        )
                    }} required />
                    <InfoIcon icon={inputpasswordicon} onClick={() => {
                        setinputpasswordtype(inputpasswordtype === 'text' ? 'password' : 'text')
                    }} />
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="exampleInputPassword1">Password Confirmation</label>
                <div style={{ display: 'flex', alignItems: 'center' }} >
                    <input type={inputpasswordtype} className="form-control" placeholder="Password Confirmation" defaultValue={componentState.confirmation_password} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'confirmation_password',
                                data: e.target.value
                            }
                        )
                    }} required />
                    <InfoIcon icon={inputpasswordicon} onClick={() => {
                        setinputpasswordtype(inputpasswordtype === 'text' ? 'password' : 'text')
                    }} />
                </div>
            </div>


            <button type="submit" className="btn btn-primary" disabled={!registrationToken}>Register</button>
            <Link className="btn" to='/login' >Login</Link>
        </form>
    </div>

}
